import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.c3s_1 = new (CouplingImages())('overlayPng', 'graphqlSvg', 'logoSvg', 'noPartyImagePath', 'noPlayerImagePath', 'frodo', 'samwise', 'grayson', 'wayne', 'rosie', 'wendy', 'robPng', 'autumnPng');
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var CouplingImagesClass;
function CouplingImages() {
  if (CouplingImagesClass === VOID) {
    class $ {
      constructor(overlayPng, graphqlSvg, logoSvg, noPartyImagePath, noPlayerImagePath, frodo, samwise, grayson, wayne, rosie, wendy, robPng, autumnPng) {
        Companion_getInstance();
        this.p3r_1 = overlayPng;
        this.q3r_1 = graphqlSvg;
        this.r3r_1 = logoSvg;
        this.s3r_1 = noPartyImagePath;
        this.t3r_1 = noPlayerImagePath;
        this.u3r_1 = frodo;
        this.v3r_1 = samwise;
        this.w3r_1 = grayson;
        this.x3r_1 = wayne;
        this.y3r_1 = rosie;
        this.z3r_1 = wendy;
        this.a3s_1 = robPng;
        this.b3s_1 = autumnPng;
      }
      toString() {
        return 'CouplingImages(overlayPng=' + this.p3r_1 + ', graphqlSvg=' + this.q3r_1 + ', logoSvg=' + this.r3r_1 + ', noPartyImagePath=' + this.s3r_1 + ', noPlayerImagePath=' + this.t3r_1 + ', frodo=' + this.u3r_1 + ', samwise=' + this.v3r_1 + ', grayson=' + this.w3r_1 + ', wayne=' + this.x3r_1 + ', rosie=' + this.y3r_1 + ', wendy=' + this.z3r_1 + ', robPng=' + this.a3s_1 + ', autumnPng=' + this.b3s_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.p3r_1);
        result = imul(result, 31) + getStringHashCode(this.q3r_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.r3r_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.s3r_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.t3r_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.u3r_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.v3r_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.w3r_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.x3r_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.y3r_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.z3r_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.a3s_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.b3s_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CouplingImages()))
          return false;
        if (!(this.p3r_1 === other.p3r_1))
          return false;
        if (!(this.q3r_1 === other.q3r_1))
          return false;
        if (!(this.r3r_1 === other.r3r_1))
          return false;
        if (!(this.s3r_1 === other.s3r_1))
          return false;
        if (!(this.t3r_1 === other.t3r_1))
          return false;
        if (!(this.u3r_1 === other.u3r_1))
          return false;
        if (!(this.v3r_1 === other.v3r_1))
          return false;
        if (!(this.w3r_1 === other.w3r_1))
          return false;
        if (!(this.x3r_1 === other.x3r_1))
          return false;
        if (!(this.y3r_1 === other.y3r_1))
          return false;
        if (!(this.z3r_1 === other.z3r_1))
          return false;
        if (!(this.a3s_1 === other.a3s_1))
          return false;
        if (!(this.b3s_1 === other.b3s_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'CouplingImages');
    CouplingImagesClass = $;
  }
  return CouplingImagesClass;
}
//region block: exports
export {
  CouplingImages as CouplingImagesci5yi3b0zpw0,
  Companion_getInstance as Companion_getInstance1l5ym9otmdi2n,
};
//endregion

//# sourceMappingURL=CouplingImages.mjs.map
